// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "semtalkapp" + "." + "840fa7c9" + ".chunk.css");